export default "__VITE_ASSET__Bwir7d1p__"